import script from "./detail-dialog-left.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-dialog-left.vue?vue&type=script&setup=true&lang=js"

import "./detail-dialog-left.vue?vue&type=style&index=0&id=3d5e4b7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5e4b7c"]])

export default __exports__